import { Link } from 'react-router-dom';

const LOGO_URL =
  'https://public.readdy.ai/ai/img_res/f8505902-009e-4945-9a23-4de9fc6b71af.png';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col justify-between bg-[#111111] overflow-hidden">

      {/* ── Subtle gold radial atmosphere ── */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(ellipse 70% 55% at 50% 55%, rgba(201,169,97,0.055) 0%, transparent 65%)',
        }}
      />

      {/* ── Top thin gold rule ── */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

      {/* ── Corner bracket decorations ── */}
      <div className="absolute top-24 left-12 w-16 h-16 border-l border-t border-gold/20" />
      <div className="absolute top-24 right-12 w-16 h-16 border-r border-t border-gold/20" />
      <div className="absolute bottom-16 left-12 w-16 h-16 border-l border-b border-gold/20" />
      <div className="absolute bottom-16 right-12 w-16 h-16 border-r border-b border-gold/20" />

      {/* ── Vertical side labels ── */}
      <div className="absolute left-10 top-1/2 -translate-y-1/2 flex flex-col items-center gap-3">
        <div className="h-16 w-px bg-gold/15" />
        <span
          className="text-gold/30 text-[9px] tracking-[0.3em] uppercase font-sans"
          style={{ writingMode: 'vertical-rl', letterSpacing: '0.3em' }}
        >
          Since 1987
        </span>
        <div className="h-16 w-px bg-gold/15" />
      </div>
      <div className="absolute right-10 top-1/2 -translate-y-1/2 flex flex-col items-center gap-3">
        <div className="h-16 w-px bg-gold/15" />
        <span
          className="text-gold/30 text-[9px] tracking-[0.3em] uppercase font-sans"
          style={{ writingMode: 'vertical-rl', letterSpacing: '0.3em' }}
        >
          Seoul · Korea
        </span>
        <div className="h-16 w-px bg-gold/15" />
      </div>

      {/* ── TOP: logo + brand name ── */}
      <div className="relative z-10 flex items-center justify-center gap-4 pt-32">
        <div className="w-px h-6 bg-gold/30" />
        <div className="w-8 h-8 rounded-full overflow-hidden ring-1 ring-gold/25">
          <img src={LOGO_URL} alt="HivanTex" className="w-full h-full object-cover" />
        </div>
        <span className="font-serif text-cream/50 text-sm tracking-[0.35em] uppercase">
          HivanTex
        </span>
        <div className="w-px h-6 bg-gold/30" />
      </div>

      {/* ── CENTER: LUXURY headline ── */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center flex-1 px-6">

        {/* Top micro-label */}
        <p className="text-gold/60 text-[9px] tracking-[0.45em] uppercase font-sans mb-8">
          핸드메이드&nbsp;불리온 엠블럼 · 명품자수
        </p>

        {/* Giant LUXURY word */}
        <h1
          className="font-serif text-cream font-light leading-none tracking-[0.06em] uppercase select-none"
          style={{ fontSize: 'clamp(5rem, 13vw, 11rem)' }}
        >
          Luxury
        </h1>

        {/* Gold divider with &  */}
        <div className="flex items-center w-full max-w-3xl gap-0 my-4">
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gold/50 to-gold/50" />
          <span
            className="font-serif italic text-gold font-light px-6 shrink-0"
            style={{ fontSize: '1.6rem', letterSpacing: '0.18em' }}
          >
            &amp; Art
          </span>
          <div className="flex-1 h-px bg-gradient-to-l from-transparent via-gold/50 to-gold/50" />
        </div>

        {/* EMBROIDERY */}
        <span
          className="font-serif text-cream font-light leading-none tracking-[0.06em] uppercase"
          style={{ fontSize: 'clamp(5rem, 13vw, 11rem)' }}
        >
          Embroidery
        </span>

        {/* Sub-line */}
        <p className="text-cream/25 text-[10px] tracking-[0.35em] uppercase font-sans mt-8">
          Premium Bullion Emblem · Handmade Craftsmanship
        </p>

        {/* CTA row */}
        <div className="flex items-center gap-5 mt-14">
          <Link
            to="/embroidery"
            className="border border-gold/55 text-gold text-[10px] tracking-[0.24em] uppercase px-12 py-4 hover:bg-gold hover:text-charcoal transition-all duration-300 font-sans whitespace-nowrap cursor-pointer"
          >
            Collection
          </Link>
          <Link
            to="/contact"
            className="border border-cream/15 text-cream/45 text-[10px] tracking-[0.24em] uppercase px-12 py-4 hover:border-cream/50 hover:text-cream/80 transition-all duration-300 font-sans whitespace-nowrap cursor-pointer"
          >
            Contact Us
          </Link>
        </div>
      </div>

      {/* ── BOTTOM: scroll indicator ── */}
      <div className="relative z-10 flex flex-col items-center gap-2 pb-10">
        <span className="text-cream/15 text-[9px] tracking-[0.3em] uppercase font-sans">
          Scroll
        </span>
        <div className="w-px h-12 bg-gradient-to-b from-cream/20 to-transparent" />
      </div>

      {/* ── Bottom thin gold rule ── */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/25 to-transparent" />
    </section>
  );
}
